import React from 'react';
const treatments = [{
  name: 'Panadol / NSAIDs',
  cost: 'RM30–50 / month',
  how: 'Blocks pain signals to your brain',
  why: "Just masks pain. Doesn't reduce inflammation or improve circulation. Plus: liver and kidney damage with long-term use.",
  icon: '❌'
}, {
  name: 'Tiger Balm / Minyak Cap Kapak',
  cost: 'RM15–25 / month',
  how: 'Creates warming/cooling sensation on skin surface',
  why: "Only penetrates 1-2mm deep. Your joint is 5cm below the surface. It's like trying to warm your house by painting the outside wall.",
  icon: '❌'
}, {
  name: 'Glucosamine Supplements',
  cost: 'RM80–150 / month',
  how: 'Oral supplement supposedly "rebuilds cartilage"',
  why: "Takes 3-6 months to *maybe* work. Doesn't address circulation or inflammation. Most people quit before seeing any effect.",
  icon: '❌'
}, {
  name: 'Physiotherapy',
  cost: 'RM150–300 / session',
  how: 'Manual therapy + exercises to strengthen muscles',
  why: "Does work—but requires 2x/week sessions for months (RM2,400+). Most Malaysians can't afford sustained treatment.",
  icon: '⚠️'
}, {
  name: 'Cheap Shopee/Lazada "Red Light" Devices',
  cost: 'RM50–150',
  how: 'Generic LED lights + vibration',
  why: 'Wrong wavelengths (usually <600nm). Inadequate power output. Reports of skin burns from unregulated devices.',
  icon: '❌'
}];
export function CostComparisonTable() {
  return <div className="my-8 font-sans" data-id="element-32">
      {/* Desktop Table */}
      <div className="hidden md:block overflow-hidden border border-gray-200 rounded-lg shadow-sm bg-white" data-id="element-33">
        <table className="w-full text-left border-collapse" data-id="element-34">
          <thead data-id="element-35">
            <tr className="bg-[#1a4d2e] text-white" data-id="element-36">
              <th className="p-4 text-sm font-bold" data-id="element-37">Treatment Method</th>
              <th className="p-4 text-sm font-bold" data-id="element-38">How It Works</th>
              <th className="p-4 text-sm font-bold" data-id="element-39">Why It Fails</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 text-sm text-[#2c2c2c]" data-id="element-40">
            {treatments.map((t, i) => <tr key={i} className="hover:bg-gray-50" data-id="element-41">
                <td className="p-4 align-top" data-id="element-42">
                  <div className="font-bold" data-id="element-43">{t.name}</div>
                  <div className="text-xs text-gray-500 mt-1" data-id="element-44">{t.cost}</div>
                </td>
                <td className="p-4 align-top" data-id="element-45">{t.how}</td>
                <td className="p-4 align-top" data-id="element-46">
                  {t.icon} {t.why}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      {/* Mobile Card Layout */}
      <div className="md:hidden space-y-4" data-id="element-47">
        {treatments.map((t, i) => <div key={i} className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm" data-id="element-48">
            <div className="flex items-start justify-between mb-3" data-id="element-49">
              <div data-id="element-50">
                <h4 className="font-bold text-[#1a4d2e] text-sm" data-id="element-51">{t.name}</h4>
                <span className="text-xs text-gray-500" data-id="element-52">{t.cost}</span>
              </div>
              <span className="text-lg" data-id="element-53">{t.icon}</span>
            </div>
            <div className="mb-2" data-id="element-54">
              <span className="text-xs font-bold text-gray-400 uppercase tracking-wide" data-id="element-55">
                How it works:
              </span>
              <p className="text-sm text-[#555] mt-1" data-id="element-56">{t.how}</p>
            </div>
            <div data-id="element-57">
              <span className="text-xs font-bold text-gray-400 uppercase tracking-wide" data-id="element-58">
                Why it fails:
              </span>
              <p className="text-sm text-[#555] mt-1" data-id="element-59">{t.why}</p>
            </div>
          </div>)}
      </div>
    </div>;
}